import { useQuery } from '@tanstack/react-query';

import { User } from '../../../../../types';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../../types/NonPaginatedResponse';
import { MIDDLE_OFFICE_BASE_PATH } from '../../../constants/middleOfficeBasePath';
import { getBdmUsers } from '../../requests/getBdmUsers';

export const useBdmUsers = (options?: { enabled?: boolean }) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    NonPaginatedResponse<User[]> | undefined
  >({
    queryKey: [MIDDLE_OFFICE_BASE_PATH, 'bdm'],
    queryFn: () => getBdmUsers(constructGet),
    staleTime: 10000,
    ...options,
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'bdmUsers'),
    ...rest,
  };
};
